module.exports = __webpack_public_path__ + "static/media/ramadhan_specials.f6c7ef6b.jpeg";